import React, {useState} from "react";

import {useDispatch} from "react-redux";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import {Chip, Container, createTheme, CssBaseline} from "@mui/material";
import {ThemeProvider} from "@mui/styles";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import {FAILED, LOADING} from "../../httpClient";
import {createStudyNote} from "../../features/study-note/studyNoteAPI";
import {useAuth} from "oidc-react";
import {fetchStudyNotesAsync} from "../../features/study-note/studyNoteSlice";
import * as STATUS from "../../httpClient";
import BackDrop from "../utils/back-drop";
import ResponsiveStack from "../utils/responsive-stack";
import {Add, Save} from "@mui/icons-material";

const theme = createTheme({
    typography: {
        fontFamily: [
            'Open Sans Condensed',
            'sans-serif'
        ].join(',')
    },
});

export const CreateStudyNote = ({ close }) => {
    const [notes, setNotes] = useState('');
    const [noteTitle, setNoteTitle] = useState('');
    const [bibleVerses, setBibleVerses] = useState('');
    const [tags, setTags] = useState([]);
    const [status, setStatus] = useState('')
    const [notesError, setNotesError] = useState(false)

    const auth = useAuth();

    const dispatch = useDispatch();

    const handleNotesChange = e => {
        setNotes(e.target.value)
    }

    const handleNoteTitleChange = e => {
        if (notesError){
            setNotesError(false)
        }
        setNoteTitle(e.target.value)
    }

    const addTag = (tag) => {
        if (tags.length === 0){
            setTags([{key: 0, value: tag}]);
        }
    }

    const save = () => {
        if (notes.length < 10) {
            setNotesError(true)
            return
        }

        setStatus(LOADING);
        const data = {
            note: notes,
            title: noteTitle,
            tags: tags,
            bibleVerses: bibleVerses
        }

        createStudyNote(auth.userData.access_token, JSON.stringify(data))
            .then(_ => {
                dispatch(fetchStudyNotesAsync(auth.userData.access_token));
                close();
            })
            .catch(error =>{
                console.log(error)
                setStatus(FAILED);
            })
    }

    const send = () => {
        if (notes.length < 10) {
            setNotesError(true)
            return
        }

        setStatus(LOADING);
    }

    return (
        <div>
            <ThemeProvider theme={theme}>
                <div>
                    <CssBaseline />
                    <Container maxWidth="lg" sx={{ mt: '3rem'}}>
                        <Box sx={{ width: '100%' }}>

                            <Stack direction={"column"} spacing={2}>
                                <TextField
                                    autoFocus
                                    fullWidth
                                    id="title"
                                    label="A title for your note"
                                    type="text"
                                    variant="outlined"
                                    onChange={handleNoteTitleChange}
                                />

                                <TextField
                                    autoFocus
                                    fullWidth
                                    multiline
                                    rows={10}
                                    id="name"
                                    label="Your study notes"
                                    type="text"
                                    variant="outlined"
                                    onChange={handleNotesChange}
                                    error={notesError}
                                />

                                <ResponsiveStack>
                                    {
                                        tags.map(tag => <Chip key={tag.key} title={tag.value} label={tag.value} clickable={true}/>)
                                    }
                                    <Chip color={'secondary'} title={'add tag'} label={'add tag'} icon={<Add/>} clickable={true}/>

                                </ResponsiveStack>
                            </Stack>

                        </Box>

                        <Box
                            sx={{
                                my: 4,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                            }}
                        >
                            <Stack direction={"row"} spacing={2}>
                                <Button size="large" color="primary" variant="contained" onClick={save}>
                                    <Save/> save
                                </Button>
                            </Stack>

                        </Box>
                    </Container>
                </div>
            </ThemeProvider>
            <BackDrop open={status === STATUS.LOADING} message={"one moment please"}/>
        </div>
    )
}
